import { createStore } from "vuex";

// 创建一个新的 store 实例
export const store = createStore({
  state() {
    return {
      articlesData: [],
      // 是否是登陆状态
      isLoggedIn: false,
      chosenImage: "",
      createAllianceData: {
        teamName: "",
        yourName: "",
        teamUrl: "",
        teamIntroduce: "",
        chosenImage: "",
      },
    };
  },
  mutations: {
    setArticlesData(state, data) {
      state.articlesData = data;
    },
    setChosenImage(state, image) {
      state.chosenImage = image;
    },
    updateAllianceData(state, payload) {
      state.createAllianceData = { ...state.createAllianceData, ...payload };
    },
  },
  actions: {
    updateArticlesData({ commit }, data) {
      commit("setArticlesData", data);
    },
    updateChosenImage({ commit }, image) {
      commit("setChosenImage", image);
    },
    // 登陆成功后更新一下这个状态
    setLoggedIn(loggedIn) {
      this.isLoggedIn = loggedIn;
    },
  },
  getters: {
    chosenImage: (state) => state.chosenImage,
    createAllianceData: (state) => state.createAllianceData,
  },
});
